// src/apollo-client.js
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL || 'http://localhost:3000/graphql',
});

// Auth middleware — also sets Content-Type to satisfy Apollo Server v4 CSRF protection
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      'content-type': 'application/json',
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

// Auto-logout on expired/invalid JWT
const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors?.some(e => e.extensions?.code === 'UNAUTHENTICATED')) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userType');
    localStorage.removeItem('userData');
    window.location.href = '/admin/login';
  }
});

// Create Apollo client
const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: new InMemoryCache()
});

// Apollo Provider Component
export const ApolloProviderWrapper = ({ children }) => (
  <ApolloProvider client={client}>
    {children}
  </ApolloProvider>
);

export default client;